import * as yup from 'yup'
import { INDUSTRY_OPTIONS } from 'constants/enums'

export const stepOneSchema = yup.object().shape({
  first_name: yup.string().required(),
  last_name: yup.string().required(),
  email: yup.string().email().required(),
  industry: yup.string().required(),
  role: yup.string().required(),
  phone: yup
    .string()
    .required()
    .matches(
      /^[+]?[0-9]{1,4}?[-.\s]?[(]?[0-9]{1,3}?[)]?[-.\s]?[0-9]{1,4}[-.\s]?[0-9]{1,9}$/
    ),
  inviter_id: yup.boolean(),
  token: yup.string(),
  hasAcceptedTerms: yup.boolean(),
  password: yup.string().when('token', {
    is: (token) => Boolean(token),
    then: () => yup.string().required(),
    otherwise: () => yup.string().notRequired()
  }),
  confirm_password: yup.string().when('token', {
    is: (token) => Boolean(token),
    then: () =>
      yup
        .string()
        .required()
        .oneOf([yup.ref('password'), null], 'Passwords must match'),
    otherwise: () => yup.string().notRequired()
  })
})

export const stepTwoSchema = yup.object().shape({
  verificationCode: yup
    .string()
    .required('Please input a valid verification code')
    .matches(/^\d{5}$/, 'Verification code must be 5 digits long')
})

export const stepThreeSchema = yup.object().shape({
  group_owner: yup.string().required(),
  web_site: yup.string(),
  country: yup.string().required(),
  state: yup.string().when('country', {
    is: (country) => country === 'CA' || country === 'US',
    then: () => yup.string().required(),
    otherwise: () => yup.string()
  }),
  city: yup.string().required(),
  reporting: yup.string().when('industry', {
    is: (industry) => industry === INDUSTRY_OPTIONS.RADIO,
    then: () => yup.string().required(),
    otherwise: () => yup.string().notRequired()
  }),
  call_letter: yup.string().when('industry', {
    is: (industry) => industry === INDUSTRY_OPTIONS.RADIO,
    then: () => yup.string().required(),
    otherwise: () => yup.string().notRequired()
  }),
  primary_format: yup.string().required(),
  secondary_format: yup.string(),
  industry: yup.string(),
  media_type: yup.string()
})
